<div [class.checked]="isDarkTheme" class="switcher-wrapper">
  <div class="toggle-container">
    <rt-icon name="light" size="small-xx" class="icon-light" />
    <div class="toggle-knob is-animated"></div>
    <rt-icon name="dark" size="small-xx" class="icon-dark" />
  </div>
</div>
